// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ddd9d421","131":"bd5f359e","453":"b03e3c98","535":"d2010f85"}[chunkId] + ".chunk.js";
};